import { UpdateForm, FormFieldsData, FormTemplateProps } from 'framework/form';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import StaffingNoteForm from './StaffingNoteForm';
import useStaffingNotesService from './staffingNotesService';

interface UpdateStaffingNoteFormProps extends Omit<FormTemplateProps, 'children' | 'getDataFunc' | 'submitFormFunc'> {
  id: string;
  onCancel: () => void;
  updateFormFunc: (noteId: string, values: FormFieldsData) => Promise<object>;
  getDataFunc: (id: string) => Promise<any>;
}

const UpdateStaffingNoteForm = ({
  id,
  updateFormFunc,
  getDataFunc,
  onCancel,
  ...props
}: UpdateStaffingNoteFormProps) => {
  const { getValidationSchema } = useStaffingNotesService();

  const handleSubmit = async (noteId: StringOrNumber, values: FormFieldsData): Promise<object> => {
    return updateFormFunc(noteId.toString(), values);
  };

  return (
    <UpdateForm
      entityId={id}
      getDataFunc={getDataFunc}
      submitFormFunc={handleSubmit}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <BaseTimelineItemFormLayout onCancel={onCancel}>
        <StaffingNoteForm />
      </BaseTimelineItemFormLayout>
    </UpdateForm>
  );
};

export default UpdateStaffingNoteForm;
